export default __webpack_public_path__ + "static/media/close-form-comer-modal.7cfc39af.svg";